import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { SettingsDTO, SettingsWriteDTO } from '../interfaces/settings';


@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private dataService: DataService) { }

    saveSettings(settingsId: number, settings: SettingsWriteDTO): Observable<SettingsDTO> {
    if (settingsId && settingsId > 0) {
      return this.dataService.updateSettings(settingsId, settings);
    } else {
      return this.dataService.createSettings(settings);
    }
  }

  deleteSettings(settings: SettingsDTO) {
    if (!settings || settings.id == null || settings.id == undefined || settings.id < 1) {
      this.dataService.deleteSettings(settings.id);
    }
  }

  getSettings(): Observable<any> {
    return this.dataService.getSettings();
  }

}
